export * from './copyQuizBySoc';
